import type { ReactNode } from 'react';
type Props = {
  label: string;
  hint?: string;
  /** Toont "12 / 110" rechts van het label. */
  count?: {
    value: number;
    max: number;
  };
  /** 'label' koppelt klikken aan het veld; 'div' voor samengestelde velden (chips, lijsten). */
  as?: 'label' | 'div';
  className?: string;
  children: ReactNode;
};

/** Label, uitleg en het veld zelf — overal in het beheer hetzelfde. */
export function Field({
  label,
  hint,
  count,
  as = 'label',
  className = '',
  children
}: Props) {
  const Wrapper = as;
  return <Wrapper className={`block ${className}`} data-id="element-4989" data-mp="198sk2oomf9g3">
      <span className="flex items-baseline justify-between gap-3" data-id="element-4990" data-mp="195woh708wwut">
        <span className="text-[13px] font-medium text-ink" data-id="element-4991" data-mp="1ny6w64jl04z6">{label}</span>
        {count && <span className={`text-[12px] tabular-nums ${count.value > count.max ? 'text-clay' : 'text-muted'}`} data-id="element-4992" data-mp="1j55g3t7n1ze0">
            {count.value} / {count.max}
          </span>}
      </span>
      {hint && <span className="mt-0.5 block text-[12px] leading-snug text-muted" data-id="element-4993" data-mp="qgghq1xyw85y">{hint}</span>}
      <span className="mt-1.5 block" data-id="element-4994" data-mp="3dx4vh38kuhf1">{children}</span>
    </Wrapper>;
}